import type { RegistrantLicenseListLicenseResponseSchema } from "@/hera-api/client/types.gen";
import { getRegistrationStatusDisplay } from "@/lib/utils";

type RegistrantLicenseStatusFields = Pick<
  RegistrantLicenseListLicenseResponseSchema,
  | "status"
  | "renewal_date"
  | "has_awaiting_check_payment"
  | "cancellation_reason"
  | "has_awaiting_invoice_payment"
  | "is_renewable"
>;

function registrationDisplayLabel(
  license: RegistrantLicenseStatusFields,
): string {
  return getRegistrationStatusDisplay(
    license.status,
    license.renewal_date,
    license.has_awaiting_check_payment,
    license.cancellation_reason,
    license.has_awaiting_invoice_payment,
    license.is_renewable,
    true,
  ).label;
}

/** Same cohort as the registrant dashboard Balance Due tab. */
export function matchesRegistrantBalanceDueTileCohort(
  license: RegistrantLicenseStatusFields,
): boolean {
  return registrationDisplayLabel(license) === "Balance Due";
}

/** Renewal Due or Renewal Overdue display status (Renewable tile and tab). */
export function matchesRegistrantRenewableTileCohort(
  license: RegistrantLicenseStatusFields,
): boolean {
  const label = registrationDisplayLabel(license);
  return label === "Renewal Due" || label === "Renewal Overdue";
}
